export function ProfessionalAchievementsDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Professional Achievement Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Achievement Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Achievement Type <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select achievement type</option>
              <option value="award">Award/Recognition</option>
              <option value="project">Project Success</option>
              <option value="certification">Certification</option>
              <option value="innovation">Innovation/Patent</option>
              <option value="publication">Publication/Speaking</option>
            </select>
          </div>

          {/* Achievement Title */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Achievement Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter achievement title"
            />
          </div>

          {/* Organization/Company */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Organization/Company <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter organization name"
            />
          </div>

          {/* Date Achieved */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date Achieved <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Recognition Level */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Recognition Level
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select level</option>
              <option value="company">Company Level</option>
              <option value="industry">Industry Level</option>
              <option value="national">National Level</option>
              <option value="international">International Level</option>
            </select>
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Reference/ID Number */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Reference/ID Number
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter reference or ID number"
            />
          </div>

          {/* Expiration Date (if applicable) */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Expiration Date
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 